import { FunctionComponent, ReactNode, Ref } from "react";
import { SelectContainer, Select, ArrowIcon } from "./styles";
import { TextError } from "../../shared/styles/global.styles";
import { Colors } from "../../shared/colors/colors";

interface SelectProps {
  color: string;
  placeholder: string;
  isPlaceHolder?: boolean;
  id: string;
  width?: number;
  name?: string;
  border?: string;
  style?: React.CSSProperties;
  value: string | null;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  ref?: Ref<HTMLSelectElement>;
  disabled?: boolean;
  className?: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  onIconLeftClick?: () => void;
  onIconRightClick?: () => void;
  options: Array<{ value: string; label: string }>;
  errorMessage?: string;
}

const SelectComponent: FunctionComponent<SelectProps> = ({
  color,
  placeholder,
  isPlaceHolder = true,
  id,
  width,
  name,
  value,
  onChange,
  iconLeft,
  iconRight,
  onIconLeftClick,
  onIconRightClick,
  options,
  disabled = false,
  errorMessage,
  ...props
}) => {
  // Determinar a cor correta - se o valor estiver vazio, usar a cor do placeholder
  const textColor =
    value != ""
      ? !disabled
        ? "placeholder-select"
        : "value-select"
      : !isPlaceHolder
      ? "value-select"
      : "placeholder-select";

  return (
    <>
      <SelectContainer
        width={width}
        hasIconLeft={!!iconLeft}
        hasIconRight={!!iconRight}
        error={!!errorMessage}
        disabled={disabled}
      >
        {iconLeft && (
          <span onClick={onIconLeftClick} style={{ cursor: "pointer" }}>
            {iconLeft}
          </span>
        )}
        <Select
          color={textColor}
          placeholder={placeholder}
          name={name}
          id={id}
          value={value ?? ""}
          disabled={disabled}
          onChange={onChange}
          error={!!errorMessage}
          className={
            value != ""
              ? !disabled
                ? "value-select"
                : "placeholder-select"
              : !isPlaceHolder
              ? "value-select"
              : "placeholder-select"
          }
          {...props}
        >
          {placeholder && (
            <option value="" style={{ color: Colors.placeholder }}>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              style={{ color: Colors.black }}
            >
              {option.label}
            </option>
          ))}
        </Select>
        <ArrowIcon /> {/* A seta personalizada */}
        {iconRight && (
          <span onClick={onIconRightClick} style={{ cursor: "pointer" }}>
            {iconRight}
          </span>
        )}
      </SelectContainer>
      {errorMessage && <TextError>{errorMessage}</TextError>}
    </>
  );
};

export default SelectComponent;
